module.exports = __webpack_public_path__ + "static/media/icon_wait.8785fb55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_wait.svg
// module id = 871
// module chunks = 7